import { render, staticRenderFns } from "./PTU.vue?vue&type=template&id=33873b02&scoped=true"
import script from "./PTU.vue?vue&type=script&lang=js"
export * from "./PTU.vue?vue&type=script&lang=js"
import style0 from "./PTU.vue?vue&type=style&index=0&id=33873b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33873b02",
  null
  
)

export default component.exports